import { render, staticRenderFns } from "./ViceTabBar.vue?vue&type=template&id=7d26886c&scoped=true&"
import script from "./ViceTabBar.vue?vue&type=script&lang=js&"
export * from "./ViceTabBar.vue?vue&type=script&lang=js&"
import style0 from "./ViceTabBar.vue?vue&type=style&index=0&id=7d26886c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d26886c",
  null
  
)

export default component.exports